<template>
    <div>
        <header-page
			name="apps"
			:title="$route.meta.title"
		/>
        <section class="main-container">
            <div class="item-list-container">
                <ul class="item-list">
                    <li v-for="item in items" :key="item.id" class="item">
                        <button class="item-button" :class="{ 'disabled': item.disabled }" @click="changeCode(item.code)" :disabled="item.disabled">
                            {{ item.name }}
                        </button>
                    </li>
                </ul>
            </div>
            <div class="additional-component">
                <configuration-subsidiary
                    v-if="modalCode === 'CP'"
                    :data="data"
                    @update:subsidiaries="updateProdSub"/>
                <configuration-products
                    v-if="modalCode === 'PR'"
                    :data="data"
                    @update:productLimit="updateProdSub"/>
                <configuration-employee 
                    v-if="modalCode === 'CE'"
                    :data="data"
                    @update:employeeCount="updateEmployee"/>
                <configuration-kardex 
                    v-if="modalCode === 'KE'"
                    :data="data"
                    @update:flagKardex="updateParamsGlobal"/>
                <configuration-params-globales 
                    v-if="modalCode === 'PG'"
                    :data="data"
                    @update:flagKardex="updateParamsGlobal"/>
                <configuration-payment-methods 
                    v-if="modalCode === 'PM'"
                    :data="data"
                    @update-settings="updateSettings"/>
                <configuration-documents
                    v-if="modalCode === 'DP'"
                    :data="data"
                    :show-purchase="true"
                    :show-sales="false"
                    @update-settings-documents="updateSettingsDocuments"/>
                <configuration-documents
                    v-if="modalCode === 'DS'"
                    :data="data"
                    :show-purchase="false"
                    :show-sales="true"
                    @update-settings-documents="updateSettingsDocuments"/>
            </div>
        </section>
        <section class="modal-filter-footer">
			<modal-sidebar-button
				success-text="Guardar"
                :is-loading="false"
				@accept-button-clicked="saveDataGeneral"
				@cancel-button-clicked="backList"
			/>
		</section>
    </div>
    
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import configurationEmployee from '@/components/configuration-general/configuration-employee';
import configurationKardex from '@/components/configuration-general/configuration-kardex';
import configurationParamsGlobales from '@/components/configuration-general/configuration-params-globales';
import configurationSubsidiary from '@/components/configuration-general/configuration-subsidiary';
import configurationPaymentMethods from '@/components/configuration-general/configuration-payment-methods';
import configurationProducts from '@/components/configuration-general/configuration-products';
import asignEmployee from '@/components/configuration-general/asign-employee';
import configurationDocuments from '@/components/configuration-general/configuration-documents';

function created() {
    ({ codeProject: this.codeProject, idTemplate: this.idTemplate } = this.$route.params);
    this.loadData();
}

async function loadData() {
    try {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const response = await this.$http.get(`template/${this.idTemplate}`, { headers });
        this.data = response.data.data;
        this.settings = this.data.items.data.settings;
        this.employeeCount = this.data.settings.company && this.data.settings.company.employeeCount || 0;
        this.domains = this.data.settings && this.data.settings.domains ?
            this.data.settings.domains : [];
        this.modalCode = 'CP';
	} catch (error) {
    console.log(error);
		this.showError();
	}
}

function data() {
    return {
        items: [
            { id: 1, name: 'Empleados', code: 'CE' },
            { id: 2, name: 'Compañía', code: 'CP' },
            { id: 3, name: 'Productos', code: 'PR' },
            { id: 4, name: 'Kardex', code: 'KE' },
            { id: 5, name: 'Fac. Electrica', code: 'FE', disabled: true },
            { id: 6, name: 'Param. Globales', code: 'PG' },
            { id: 7, name: 'Medios Pagos', code: 'PM' },
            { id: 8, name: 'Doc. Compra', code: 'DP' },
            { id: 9, name: 'Doc. Venta', code: 'DS' },
        ],
        action: {
            title: '',
            open: false,
            code: '',
            width: 0,
        },
        modalCode: '',
        idTemplate: null,
        codeProject: null,
        subsidiaries: [],
        limitProducts: 0,
        data: {},
        settings: {},
        employeeCount: 0,
        domains: [],
    };
}

export default {
    name: 'page-configuration-general',
    created,
    data,
    components: {
        actionSidebar,
        configurationSubsidiary,
        asignEmployee,
        configurationProducts,
        configurationKardex,
        configurationEmployee,
        configurationPaymentMethods,
        configurationParamsGlobales,
        configurationDocuments,
    },
    methods: {
        loadData,
        changeCode(code) {
            this.modalCode = code;
        },
        updateProdSub(newVal, model) {
            if (model === 'limitProducts') {
                this.limitProducts = newVal;
            } else if (model === 'subsidiaries') {
                this.subsidiaries = newVal;
            }
        },
        updateParamsGlobal(newVal) {
            this.settings = newVal;
        },
        updateEmployee(newVal) {
            this.data.settings.company.employeeCount = Number(newVal);
            this.employeeCount = Number(newVal);
        },
        backList() {
            this.goTo('page-template');
        },
        calculateTotalQuantity() {
            let totalQuantity = 0;

            this.subsidiaries.forEach(subsidiary => {
                subsidiary.warehouse.forEach(warehouse => {
                    warehouse.user.forEach(user => {
                        totalQuantity += parseInt(user.quantity, 10);
                    });
                });
            });

            return Number(totalQuantity);
        },
        async saveDataGeneral() {
            if (this.calculateTotalQuantity() > this.employeeCount) {
                this.showError('La cantidad de empleados excede al total de empleados configurados');
                return;
            }
            const headers = {
                Accept: `${process.env.ACCEPT_SERVICE_V2}`,
            };
            const companyNew = {
                employeeCount: Number(this.employeeCount),
                subsidiary: this.subsidiaries,
                subsidiaryCount: this.subsidiaries.length,
                productLimit: Number(this.limitProducts),
            };
            const body = {
                name: this.data.name,
                description: this.data.description,
                settings: {
                    domains: this.domains,
                    company: companyNew,
                },
            };
            const dataItem = this.data.items.data;
            const bodySetting = {
                description: dataItem.description,
                flagActive: Boolean(dataItem.flagActive),
                name: dataItem.name,
                settings: this.settings,
            };
            try {
                await this.$http.put(`template/${this.idTemplate}`, body, { headers });
                await this.$http.put(`project/${this.codeProject}/items/${dataItem.id}`, bodySetting);
                this.loadData();
                this.backList();
            } catch (err) {
                if (err.status === 500) {
                    this.showError();
                }
            }
        },
        updateSettings({ key, value }) {
            this.settings.typePaymentsInit[key] = value;
            console.log('this.settings', this.settings);
        },
        updateSettingsDocuments({ key, value }) {
            if (!this.settings.msTypeDocumentInit) {
                this.$set(this.settings, 'msTypeDocumentInit', {});
            }
            this.$set(this.settings.msTypeDocumentInit, key, value);
        },
    },
};
</script>

<style scoped>

.main-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 10px;
  margin-top: 20px;
}

.content {
  display: flex;
  align-items: flex-start;
}

.item-list-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin-right: 20px;
}

.item-list {
  list-style-type: none;
  padding: 0;
  width: 300px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.item {
  border-bottom: 1px solid #ddd;
}

.item:last-child {
  border-bottom: none;
}

.item-button {
  width: 100%;
  background-color: #909090;
  color: white;
  border: none;
  border-radius: 0;
  padding: 15px 0;
  cursor: pointer;
  text-align: left;
  padding-left: 20px;
  font-size: 16px;
  transition: background-color 0.3s, color 0.3s;
}

.item-button:hover {
  background-color: #6d6d6d;
  color: #fff;
}

.additional-component {
  flex: 1;
  margin-right: 30px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  height: 73vh;
}

.item-button.disabled {
    background-color: #c7c7c7;
    cursor: not-allowed;
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration-general/page-configuration-general-v2.vue